import { Component, OnInit } from '@angular/core';
import { OrgService } from '../_services/org.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
	selector: 'dropdown-area',
	templateUrl: './dropdown-area.component.html',
})
export class DropdownAreaComponent implements OnInit {
	subscriptions: Subscription[] = [];
	public areas: any;
	public selectedArea: any;
	constructor(public orgService: OrgService) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.areas$.subscribe((data: any) => {
				console.log(data);
				this.areas = data;
			}),
		);

		this.subscriptions.push(
			this.orgService.selectedArea$.subscribe((data: any) => {
				this.selectedArea = data;
			}),
		);
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
